import { useForm, UseFormOptions } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import * as yup from 'yup'

export const NewInterestSchema = yup
  .object({
    contactEmail: yup
      .string()
      .email('Please enter a valid email.')
      .required('Please enter your email.'),
    contactMessage: yup.string().required('Please write your message above.'),
    contactPhone: yup
      .string()
      .required('Please enter your phone number.')
      .min(10, 'Phone number is not valid'),
  })
  .required()

export type NewInterestSchemaType = yup.InferType<typeof NewInterestSchema>

type TOmittedProps = 'mode' | 'resolver' | 'defaultValues'

interface IFormDefaultValues {
  contactEmail?: string
  contactPhone?: string
}

interface IUseLaneOfferInterestFormProps
  extends Omit<UseFormOptions<NewInterestSchemaType>, TOmittedProps> {
  formDefaultValues?: IFormDefaultValues
}

export const useLaneOfferInterestForm = (props: IUseLaneOfferInterestFormProps = {}) => {
  const { formDefaultValues } = props || {}
  const { contactEmail = undefined, contactPhone = undefined } = formDefaultValues || {}
  return useForm({
    mode: 'all',
    resolver: yupResolver(NewInterestSchema),
    defaultValues: NewInterestSchema.cast({
      contactMessage: undefined,
      contactEmail,
      contactPhone,
    }),
    ...props,
  })
}
